import PropTypes from 'prop-types';
import React from 'react';

const GenericFormItem = function GenericFormItem(props) {
  const {
    label,
    children,
  } = props;
  return (
    <div className="uk-grid">
      <div className="uk-width-medium-2-5 uk-width-small-1-3 uk-width-mobile-1-3 form-heading">
        <h4 className="uk-margin-small-bottom">{label}</h4>
      </div>
      <div className="uk-width-medium-3-5 uk-width-small-2-3 uk-width-mobile-2-3 form-value dont-break-out">
        {children}
      </div>
    </div>
  );
};

GenericFormItem.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
    PropTypes.array,
  ]).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
    PropTypes.array,
  ]).isRequired,
};

export default GenericFormItem;



// WEBPACK FOOTER //
// ./src/components/GenericFormItem.js